import Ajax from '@utils/ajax';

export function postCompanyInfo(data) {
	return Ajax.post('/settings/account/account_info.php', data);
}
